import { NgModule } from '@angular/core';
import { LockerDatePage } from './locker-date.page';
import { SharedModule } from 'app/shared.module';
import { BlockDateComponent } from 'app/components/shared/block-date/block-date.component';

@NgModule({
  imports: [
    SharedModule,
    BlockDateComponent
  ],
  declarations: [LockerDatePage]
})
export class LockerDatePageModule {}
